import React, { Component } from "react";
import ReactDOM from "react-dom";

import "./Toast.scss";

/* The dashboard's toast -- the dark pill at the top centre, with the severity
 * chip that pops in and rings once (frontend-hiilt-manasa/src/index.scss,
 * "Toast -- compact pill"). The dashboard draws it on PrimeReact's <Toast>;
 * this site has no PrimeReact, so the same pill is drawn here by hand and
 * Toast.scss carries the dashboard's values.
 *
 * Display only. A page keeps the message state it already had and hands it
 * over in place of the line it used to print:
 *
 *   <Toast msg={msg} />                  msg = { text, type } or null
 *   <Toast msg={error} type="error" />   a bare string
 *
 * A new message (a new object, or new text) shows the pill again. Success
 * leaves after 3s, as on the dashboard; a warning or an error stays until it
 * is closed, because some of them are the only explanation of an empty page.
 *
 * Rendered into <body> so no transformed ancestor can trap the fixed pill.
 */
const LIFE_MS = 3000;

// The page vocabulary ("warning") to the dashboard's severities.
const SEVERITY = { success: "success", warning: "warn", warn: "warn", error: "error", info: "info" };

class Toast extends Component {
  state = { open: !!this.props.msg, leaving: false };

  componentDidMount() {
    if (this.state.open) this.arm();
  }

  componentDidUpdate(prev) {
    const { msg } = this.props;
    if (msg === prev.msg) return;
    clearTimeout(this.timer);
    clearTimeout(this.exitTimer);
    if (msg) {
      this.setState({ open: true, leaving: false }, () => this.arm());
    } else {
      this.setState({ open: false, leaving: false });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.exitTimer);
  }

  severity() {
    const { msg, type } = this.props;
    const raw = (msg && typeof msg === "object" && msg.type) || type || "info";
    return SEVERITY[raw] || "info";
  }

  arm() {
    if (this.severity() === "success") this.timer = setTimeout(this.close, LIFE_MS);
  }

  close = () => {
    clearTimeout(this.timer);
    this.setState({ leaving: true });
    this.exitTimer = setTimeout(() => this.setState({ open: false, leaving: false }), 220);
  };

  render() {
    const { msg } = this.props;
    const { open, leaving } = this.state;
    if (!open || !msg) return null;

    const text = typeof msg === "object" ? msg.text : msg;
    const severity = this.severity();
    const urgent = severity === "error" || severity === "warn";

    return ReactDOM.createPortal(
      <div className="tst-stack">
        <div
          key={text}
          className={`tst is-${severity}${leaving ? " is-leaving" : ""}`}
          role={urgent ? "alert" : "status"}
          aria-live={urgent ? "assertive" : "polite"}
        >
          <span className="tst-icon" aria-hidden="true"></span>
          <span className="tst-text" dir="auto">{text}</span>
          <button type="button" className="tst-close" aria-label="إغلاق" onClick={this.close}></button>
        </div>
      </div>,
      document.body
    );
  }
}

export default Toast;
